<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        md="4"
      />

      <b-col
        cols="12"
        md="4"
      >
        <b-card>
          <template v-if="success">
            <p class="mb-0">
              Your password has been reset. You should receive an email shortly with your new login details.
            </p>

            <div class="mt-2 text-center">
              <b-link :to="{ name: 'login' }">
                Back to login
              </b-link>
            </div>
          </template>

          <template v-else-if="invalid">
            <p class="mb-0 text-danger">
              This reset link is invalid or has expired. Please request a new password reset.
            </p>

            <div class="mt-2 text-center">
              <b-link :to="{ name: 'forgot-password' }">
                Back to forgot password
              </b-link>
            </div>
          </template>

          <template v-else>
            <p class="mb-0 text-muted">
              Verifying your reset link...
            </p>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BLink,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BLink,
  },
  data() {
    return {
      success: false,
      invalid: false,
    }
  },
  mounted() {
    const { resetcode } = this.$route.query
    if (!resetcode) {
      this.invalid = true
      return
    }
    this.$http.post('public.cfc?method=confirmPasswordReset', new URLSearchParams({
      resetcode,
    }))
      .then(response => {
        if (response.data === true) {
          this.success = true
        } else {
          this.invalid = true
        }
      })
      .catch(error => {
        console.log(error)
        this.invalid = true
      })
  },
}
</script>
